import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ICollectionTagFields } from '@/types/contentful/contentful';
import { FilterItem } from '@/components/molecules';
import { ICategoriesListMobileCmp } from './ICategoriesListMobileCmp';
import { useRouter } from 'next/router';
import { useTranslation, TFunction } from 'next-i18next';
import { ICmsCategoriesFilters } from '@/types/collections';
import { getLabel } from '@/utils/index';
import { FacetValue } from '@/lib/models/types/product';

const FilterItemWrapper = styled.div`
  margin-bottom: 4px;
`;

const CategoriesWrapper = styled.div`
  padding: 0 12px;
  height: calc(100% - 150px);
  overflow-y: auto;
`;
const CategoriesListMobile: React.FC<ICategoriesListMobileCmp> = ({
  catalogGenders,
  queryParameters,
  cmsCollectionTags,
  categorySelectHandler,
  selected,
  facetFoundValues,
  all,
}) => {
  const { t } = useTranslation(['catalog']);
  const [list, setList] = useState<any[]>([]);
  const router = useRouter();

  let { slug } = router.query;
  useEffect(() => {
    let list: any[] = [];

    if (
      !selected ||
      selected.length === 0 ||
      (selected && selected.length === 1 && (!slug || slug.length === 0))
    ) {
      list = getBrowseGenders(
        catalogGenders,
        selected,
        categorySelectHandler,
        t
      );
    } else {
      if (cmsCollectionTags) {
        list = getBrowseCategories(
          facetFoundValues,
          selected as string[],
          queryParameters,
          categorySelectHandler,
          slug as string[],
          all,
          t,
          cmsCollectionTags
        );
      }
    }

    setList(list);
  }, [selected]);

  return (
    <CategoriesWrapper className={'customWrapper'}>{list}</CategoriesWrapper>
  );
};

export default CategoriesListMobile;

const getBrowseGenders = (
  catalogGenders: ICollectionTagFields[],
  selected: string[],
  categorySelectHandler: (selected: string[]) => void,
  t: TFunction
): JSX.Element[] => {
  const filterLinks = [];
  filterLinks.push(
    <FilterItemWrapper key={`filter-all-products`}>
      <FilterItem
        label={t('catalog:all-products')}
        active={!selected || selected.length === 0 ? true : false}
        clickHandler={() => {
          categorySelectHandler([]);
        }}
        hasChildren={false}></FilterItem>
    </FilterItemWrapper>
  );

  for (const gender of catalogGenders) {
    filterLinks.push(
      <FilterItemWrapper key={`filter-${gender.slug}`}>
        <FilterItem
          label={gender?.label || gender.slug}
          active={
            selected && selected[0] && selected[0] === gender.slug
              ? true
              : false
          }
          clickHandler={() => {
            categorySelectHandler([gender.slug]);
          }}
          hasChildren={false}></FilterItem>
      </FilterItemWrapper>
    );
  }

  return filterLinks;
};

const getBrowseCategories = (
  categoryPathFacetValues: FacetValue[],
  selected: string[],
  queryParameters: { [key: string]: string | string[] | undefined },
  categorySelectHandler: (selected: string[]) => void,
  slug: string[],
  all: string[],
  t: TFunction,
  cmsCollectionTags: ICmsCategoriesFilters
): JSX.Element[] => {
  let cat = [];

  if (categoryPathFacetValues && categoryPathFacetValues.length > 0) {
    //  for each category I get the relative CMS label (if it exists)
    categoryPathFacetValues.forEach(categoryPath => {
      // const collectionTagsGroup = categoryPath?.queryValue.split('/')[0];
      categoryPath.displayValue = getLabel(
        categoryPath.queryValue,
        cmsCollectionTags.categories[categoryPath?.queryValue],
        categoryPath?.displayValue
      );
    });

    //  I sort the categories by labels
    categoryPathFacetValues = categoryPathFacetValues.sort((a, b) =>
      a.displayValue.localeCompare(b.displayValue)
    );

    // TODO: in a collection refactor some categoryPathArray loop could be avoided to improve performance
    // TODO: a refactor is needed to share the same logic between CategoriesList and CategoriesListMobile as well

    cat.push(
      <FilterItemWrapper key={`filter-all-products`}>
        <FilterItem
          label={t('catalog:all-products')}
          active={selected.join('/') === all.join('/')}
          clickHandler={() => {
            categorySelectHandler(all);
          }}
          hasChildren={false}></FilterItem>
      </FilterItemWrapper>
    );

    categoryPathFacetValues.forEach((categoryPath, index) => {
      let isActiveCategoryPath: boolean = false;

      if (selected && selected.length > 0) {
        isActiveCategoryPath =
          selected.slice(1).join('/') === categoryPath.queryValue;
      } else {
        if (queryParameters['category-path']) {
          isActiveCategoryPath =
            queryParameters['category-path'] === categoryPath.queryValue;
        }
      }

      let splitCategoryPath = categoryPath?.queryValue.toLowerCase().split('/');

      let label = categoryPath?.displayValue;
      let linkQueryParameters = { ...queryParameters };

      if (
        (!selected || selected.length === 0) &&
        categoryPath?.queryValue !== ''
      ) {
        linkQueryParameters = {
          ...linkQueryParameters,
          ...{
            'category-path': categoryPath?.queryValue,
          },
        };
      }

      let catParameter = {};

      if (!selected || selected?.length === 0) {
        if (isActiveCategoryPath) {
          splitCategoryPath = splitCategoryPath.slice(
            0,
            splitCategoryPath.length - 1
          );
        }
        let arrCatString = splitCategoryPath.join('/');

        if (arrCatString.length > 0) {
          catParameter = { 'category-path': arrCatString };
          linkQueryParameters = {
            ...linkQueryParameters,
            ...catParameter,
          };
        } else {
          delete linkQueryParameters['category-path'];
        }
      }

      let filterItem = (
        <FilterItemWrapper key={`filter-${categoryPath?.id}${index}`}>
          <FilterItem
            label={label}
            active={
              selected && selected.length > 0
                ? selected.slice(1).join('/') === categoryPath?.queryValue
                : false
            }
            clickHandler={() => {
              let categoryToSet = [];
              if (
                slug &&
                slug.length > 0 &&
                slug.slice(1).join('/').includes(categoryPath?.queryValue)
              ) {
                categoryToSet = slug;
              } else {
                categoryToSet = [
                  selected && selected.length > 0 ? selected[0] : '',
                  ...categoryPath?.queryValue.split('/'),
                ];
              }

              categorySelectHandler(categoryToSet);
            }}
            hasChildren={
              categoryPath.values && categoryPath.values.length > 0
            }></FilterItem>
        </FilterItemWrapper>
      );

      cat.push(filterItem);
    });
  }

  return cat;
};
